import React from "react";

const RoomStatusLegend = () => {
  const statuses = [
    { label: "PENDING CHECKOUT", color: "#616161" }, // Dark gray
    { label: "VACANT DIRTY", color: "#E91E63" }, // Pink
    { label: "DY", color: "#9C27B0" }, // Purple
    { label: "JM", color: "#9C27B0" }, // Purple
    { label: "MF", color: "#9C27B0" }, // Purple
    { label: "RG", color: "#9C27B0" }, // Purple
    { label: "", icon: "🔍", color: "#03A9F4" }, // Magnifying glass
    { label: "READY TO OCCUPY", color: "#03A9F4" }, // Light blue
    { label: "CHECKED IN TODAY", color: "#FFC107" }, // Orange
    { label: "DND", icon: "🚪", color: "#d9d9d9" }, // Do Not Disturb
    { label: "STAYOVER DIRTY", color: "#E91E63" }, // Pink
    { label: "STAYOVER CLEAN", color: "#03A9F4" }, // Light blue
  ];

  return (
    <div className='justify-content-center position-relative'
      style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
      {statuses.map((status, index) => (
        status.label !== 'DND' ?
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "80px",
              height: "80px",
              borderRadius: "5px",
              backgroundColor: status.color,
              color: "white",
              fontWeight: "bold",
              fontSize: status.icon ? 20 : 11,
              textAlign: "center",
            }}
          >
            {status.icon ? status.icon : status.label}
          </div> :
          <div className="position-relative" style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "5px",
            color: "white",
            fontWeight: "bold",
            fontSize: status.icon ? 20 : 11,
            textAlign: "center",
          }}>
            <div className="dnd-hanger position-static" key={index} style={{ width: 50, height: 75 }}>
              <div className="hanger-hole" style={{ top: 20, height: 15, width: 15 }}></div>
              <div className="hanger-body pt-2">
                <span className="dnd-text" style={{ fontSize: 12 }}>DND</span>
              </div>
            </div>
          </div>
      ))}
    </div>
  );
};

export default RoomStatusLegend;
